module.exports = __webpack_public_path__ + "img/zazen.fbf68a85.png";